import Vue from 'vue'
import VueDaumPostcode from 'vue-daum-postcode'

const options = {}

Vue.use(VueDaumPostcode, options)
